import { GQL } from 'src/graphql';
import { AdapterFunc } from 'src/hooks/useEntityAdapter';
import { FailedReasonModel } from '../models/failedReason.model';

export const failedReasonAdapter: AdapterFunc<
  GQL.SubTableByCompanyElasticResponse,
  FailedReasonModel
> = (input) => ({
  id: input.id!,
  company: input.company!,
  data: input.data!,
});
